import {
  ADD_NFT_TO_CART,
  REMOVE_NFT_FROM_CART,
  SET_CART_LOADING,
  SET_CART_OPEN,
  UPDATE_CART_DATA
} from '../ActionTypes';
import { ICartData, ICartNft } from 'interfaces';

export const addNftToCart = (nft: ICartNft) => {
  return {
    type: ADD_NFT_TO_CART,
    payload: nft
  };
};

export const removeNftFromCart = (id: ICartNft['id']) => {
  return {
    type: REMOVE_NFT_FROM_CART,
    payload: id
  };
};

export const setCartOpen = (open: boolean) => {
  return {
    type: SET_CART_OPEN,
    payload: open
  };
};

export const setCartLoading = (loading?: boolean) => {
  return {
    type: SET_CART_LOADING,
    payload: loading ?? true
  };
};

export const updateCartData = (data?: ICartData) => {
  return {
    type: UPDATE_CART_DATA,
    payload: data
  };
};
